import EyeIcon from '../../../../assets/eye-dark-green-icon.svg';
import FacebookIcon from '../../../../assets/facebook-icon.svg';
import LinkedinIcon from '../../../../assets/linkedin-icon.svg';
import InstagramIcon from '../../../../assets/instagram-icon.svg';
import TwitterIcon from '../../../../assets/twitter-icon.svg';
import AvatarDefault from '../../../../assets/medium_default_optimized.png';
import VerifiedIcon from '../../../../assets/verified-icon.svg';
import FoundingCreatorIcon from '../../../../assets/founding_creator_icon.png';
import Button from '../../../Button';
import { profileAtom } from '../../../Settings/atom';
import { useAtom } from 'jotai';
import { useNavigate } from 'react-router-dom';
import useTruncatedElement from '../../../../hooks/useTruncatedElement';
import PointsCard from '../../../../routes/Profile/components/PointsCard';
import { useRef } from 'react';

const PreviewProfile = (props) => {
  const { avataUpload } = props;
  const [profile] = useAtom(profileAtom);
  const navigate = useNavigate();
  const readMoreRef = useRef(null);

  const { isTruncated, isReadingMore, toggleIsShowingMore } = useTruncatedElement({
    ref: readMoreRef
  });

  const socialsUrl = [
    {
      icon: FacebookIcon,
      link: profile?.socialLinks?.facebook
    },
    {
      icon: InstagramIcon,
      link: profile?.socialLinks?.instagram
    },
    {
      icon: LinkedinIcon,
      link: profile?.socialLinks?.linkedin
    },
    {
      icon: TwitterIcon,
      link: profile?.socialLinks?.twitter
    }
  ].filter((social) => social.link);

  return (
    <div className="px-4 md:px-0">
      <div className="flex justify-between items-center">
        <p className="font-[800] text-xl">Profile preview</p>
        <Button variant="secondary" onClick={() => navigate(`/${profile.username}`)}>
          View full profile
          <img src={EyeIcon} className="ml-2" alt="" />
        </Button>
      </div>
      <div className="mt-[10px] flex flex-col md:flex-row gap-6">
        <img
          src={avataUpload || profile.imgUrl || AvatarDefault}
          className="h-[188px] w-[188px] flex-shrink-0 rounded-[16px] object-cover self-center md:self-start"
          alt=""
        />
        <div className="gap-4 flex flex-col w-full overflow-hidden">
          <div>
            <div className="flex gap-2 items-center">
              <p className="text-2xl font-[800] truncate">{profile.firstName} </p>
              {profile.isVerifiedAuthor && <img src={VerifiedIcon} className="w-8 h-8" alt="" />}
              {profile.isFoundingCreator && (
                <img
                  src={FoundingCreatorIcon}
                  className="w-8 h-8"
                  alt="Founding Creator"
                  title="Founding Creator"
                />
              )}
            </div>
            {profile.username && (
              <span className="font-[600] text-lg text-02-dim-gray">@{profile.username}</span>
            )}
          </div>
          <div className="flex flex-col gap-2">
            <p className="font-[800] text-lg">About me</p>
            <p
              ref={readMoreRef}
              className={`text-sm whitespace-pre-wrap ${!isReadingMore && 'line-clamp-[10]'}`}
            >
              {profile.description || 'No description'}
            </p>
            {isTruncated && (
              <div onClick={toggleIsShowingMore} className="cursor-pointer">
                <p className="text-sm font-[900] text-growth-green-500 cursor-pointer hover:opacity-80 mt-[8px]">
                  {isReadingMore ? 'Show less' : 'Read more'}
                </p>
              </div>
            )}
          </div>
          <div className="flex flex-wrap gap-4 mt-auto justify-start">
            <div className="flex items-center text-sm space-x-2">
              <span className="font-bold">{profile.followerNumber}</span>
              <span>followers</span>
            </div>
            <div className="flex items-center text-sm space-x-2">
              <span className="font-bold">{profile.followingNumber}</span>
              <span>following</span>
            </div>
            <div className="flex items-center text-sm space-x-2">
              <span className="font-bold">{profile.contributionNumber}</span>
              <span>articles</span>
            </div>
          </div>
          <PointsCard
            earnedPoints={profile?.receivedReputation?.totalPoints ?? 0}
            givenPoints={profile?.sentReputation?.totalPoints ?? 0}
            readers={profile?.receivedReputation?.totalUsers ?? 0}
            writers={profile?.sentReputation?.totalUsers ?? 0}
          />
          <div className="flex gap-2">
            {socialsUrl.map((item, index) => (
              <a
                className="cursor-pointer"
                href={item.link}
                key={index}
                target="_blank"
                rel="noreferrer"
              >
                <img src={item.icon} alt="" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewProfile;
